import { render } from "./Keeper.vue?vue&type=template&id=f4ae8fb6&scoped=true"
import script from "./Keeper.vue?vue&type=script&lang=js"
export * from "./Keeper.vue?vue&type=script&lang=js"

import "./Keeper.vue?vue&type=style&index=0&id=f4ae8fb6&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ae8fb6"]])

export default __exports__